import { Directive, Input } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';

@Directive()
export abstract class AbstractInputComponent {
  @Input() idHTML!: string;
  @Input() label = '';
  @Input() prefix = '';
  @Input() suffix = '';
  @Input() placeholder = '';
  @Input() maxLength?: number;
  @Input() showCharCount = false;

  get isRequired() {
    return this._control.hasValidator(Validators.required);
  }

  _control!: FormControl;
  @Input() set control(control: AbstractControl) {
    this._control = control as FormControl;
  }

  protected defaultRequiredErrorMessage() {
    return { required: 'forms.errors.required' };
  }

  defaultErrorMessages(): { [key: string]: string } {
    return this.defaultRequiredErrorMessage();
  }

  @Input() set errorMessages(
    errMess: Record<string, string | { message: string; params: Record<string, any> }>,
  ) {
    this._errorMessages = { ...this.defaultErrorMessages(), ...errMess };
  }

  _errorMessages: Record<string, string | { message: string; params: Record<string, any> }> =
    this.defaultErrorMessages();

  get errorMessage() {
    if (!this._control.errors) {
      return '';
    }
    for (const key of Object.keys(this._errorMessages)) {
      if (this._control.errors[key]) {
        if (typeof this._errorMessages[key] === 'string') {
          return this._errorMessages[key];
        } else {
          return this._errorMessages[key].message;
        }
      }
    }
    return '';
  }

  get errorParams() {
    if (!this._control.errors) {
      return undefined;
    }
    for (const key of Object.keys(this._errorMessages)) {
      if (this._control.errors[key]) {
        if (typeof this._errorMessages[key] === 'string') {
          return undefined;
        } else {
          return this._errorMessages[key].params;
        }
      }
    }
    return undefined;
  }

  get charCount(): number {
    return this._control?.value?.length || 0;
  }
}
